import { Component, OnInit } from '@angular/core';
import {Input} from '@angular/core';
import {NzModalRef} from 'ng-zorro-antd';
import {_HttpClient} from '@delon/theme';
import {SystemContants} from '@core/constants';
import {NzMessageService} from 'ng-zorro-antd';
import {STColumn} from '@delon/abc';
import {STRes} from '@delon/abc';
import {STReq} from '@delon/abc';
import {STComponent} from '@delon/abc';
import {ViewChild} from '@angular/core';

@Component({
  selector: 'app-send-message',
  templateUrl: './send-message.component.html',
  styles: []
})
export class SendMessageComponent implements OnInit {

  @Input()
  record: any = {};

  healers: any[] = [];
  templates: any[] = [];
  currentTemplate: any = {
    paramsList: []
  };

  smsWrapper: any = {
    templateId: null,
    healers: [],
    params: {}
  };

  smsPreview: any =null;

  histories: any[] = [];
  checkAll: boolean = false;

  @ViewChild("stHistory")
  stHistory: STComponent;
  historyColumns: STColumn[] =[
    {title: '姓名', index: 'name'},
    {title: '手机', index: 'phone'},
    {title: '发送时间', index: 'createTime'},
    {title: '状态', render: 'statusCol'},
    {title: '发送内容', render: 'contentCol'}
  ];

  stRes: STRes = {
    reName: {list: 'data.records', total: 'data.total'}
  };
  stReq: STReq = {
    method: 'POST',
    body: {}
  };
  historyUrl = null;

  constructor(private ref: NzModalRef, private http: _HttpClient, private msg: NzMessageService) { }

  ngOnInit() {
    this.stReq.body = {batchId: this.record.id};
    this.stHistory.req = this.stReq;
    this.historyUrl ="api/app/sms/history";
    this.stHistory.reload();
    this.loadHealers();
    this.loadTemplates();
  }

  cancel() {
    this.ref.close();
  }


  /**
   * 加载休养人员
   */
  loadHealers() {
    this.http.get<any>('api/app/healer/list/batch/'+this.record.id).subscribe((resp) => {
      if (resp.status === SystemContants.STATUS_SUCCESS) {
        this.healers = resp.data;
      }
    })
  }

  /**
   * 加载短信模板
   */
  loadTemplates() {
    this.http.get<any>('api/app/sms/template').subscribe((resp) => {
      if (resp.status === SystemContants.STATUS_SUCCESS) {
        this.templates = resp.data;
      }
    })
  }

  /**
   * 短信模板改变时
   * @param {string} templateId
   */
  onTemplateChange(templateId: string) {
    this.smsWrapper.params = {};
    this.templates.forEach((value) => {
      if (value.id == templateId) {
        this.currentTemplate = value;
      }
    })
    this.smsPreview =  this.currentTemplate.content;
  }

  /**
   * 参数输入改变时
   */
  onParamsChange() {
    var preview = this.currentTemplate.content;
    this.currentTemplate.paramsList.forEach((name) => {
      if (this.smsWrapper.params[name]) {
        preview = preview.replace("$" + name + "$", this.smsWrapper.params[name]);
      }
    });
    this.smsPreview = preview;
  }

  /**
   * 当休养人员被选中时
   * @param {boolean} check
   * @param healer
   */
  onHealerCheck(check: boolean, healer: any) {
    let checked = new Array();
    Object.assign(checked, this.smsWrapper.healers);
    if (check) {
      checked.push(healer);
    } else {
      checked.forEach((ckd,index) => {
        if (ckd.id == healer.id) {
          checked.splice(index,  1);
        }
      })
    }
    this.smsWrapper.healers = checked;
  }

  onHealerCheckAll(check: boolean) {
    let checked = new Array();
    if (check) {
      this.healers.forEach((healer,index) => {
        if (healer.phone!=null&&healer.phone.length==11) {
          healer.check = true;
          checked.push(healer);
        }
      });
    } else {
      this.healers.forEach((healer,index) => {
        if (healer.phone!=null&&healer.phone.length==11) {
          healer.check = false;
        }
      });
    }
    this.smsWrapper.healers = checked;
  }

  /**
   * 发送短信
   */
  toSendSms() {
    this.http.post<any>('api/app/sms/send', this.smsWrapper).subscribe((resp) => {
      if (resp.status === SystemContants.STATUS_SUCCESS) {
        this.msg.success("发送成功");
        this.smsWrapper.templateId = null;
      }
    })
  }




}
